module.exports = __webpack_public_path__ + "img/bulkenrollment_required_fields_blue_2.79027f7f.png";